import { combineReducers } from "redux";
import quoteReducer from "./reducer";

const reducer = combineReducers({
  quoteReducer,
});

export default reducer;
